var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.rows),function(index){return _c('tr',_vm._l((_vm.columns),function(index){return _c('td',[_c('Skeleton',{staticClass:"skeleton"})],1)}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }